import { useQuery } from '@tanstack/react-query';
import { PartyData, PartyExtra, PartySession } from '@types';
import { RequestApi } from '_helpers';

const getPariesList = async () => {
  return await RequestApi.get<PartySession>(`/Party`);
};

const getPartyExtras = async () => {
  return await RequestApi.get<PartyExtra>(`/Party/extras`);
};

const createPartyBooking = async (partyData: PartyData) => {
  return await RequestApi.post<PartySession>(
    `/Party/createPartyBooking`,
    partyData,
  );
};

export const PARTYLIST_QUERY_KEY = ['partylist'] as const;
export const PARTYEXTRAS_QUERY_KEY = ['partyextras'] as const;

export const usePartyList = () =>
  useQuery({
    queryKey: PARTYLIST_QUERY_KEY,
    queryFn: getPariesList,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const usePartyExtras = () =>
  useQuery({
    queryKey: PARTYEXTRAS_QUERY_KEY,
    queryFn: getPartyExtras,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

const partyService = {
  getPariesList,
  getPartyExtras,
  createPartyBooking,
};

export default partyService;
